import { T_ADULT_WELCOME_POPUP_PAGE_CONSTANTS } from './TYPES'

const EN_ADULT_WELCOME_POPUP_PAGE_CONSTANTS: T_ADULT_WELCOME_POPUP_PAGE_CONSTANTS =
  {
    TITLE: 'Welcome to GriffyReads!',
    KICKER: 'Before your child can start reading...',
    BODY: 'GriffyReads is designed for children. To access quizzes, reading challenges and events, your child needs their own account, which you can create in less than a minute.',
    STEP_1_TITLE: '1. Create Child Account',
    STEP_1_BODY: "Add your child's profile in a few simple steps.",
    STEP_2_TITLE: '2. Child Logs In',
    STEP_2_BODY:
      'They use their own account to enter GriffyReads and complete quizzes.',
    STEP_3_TITLE: '3. Read, Play & Grow',
    STEP_3_BODY:
      'They can complete quizzes, earn points and join reading challenges and events!',
    PRIMARY_CTA: 'Create a Child Account',
    SECONDARY_CTA: 'Maybe later',
    FOOTER:
      'Adult accounts are free. Children cannot create accounts on their own.'
  }

export default EN_ADULT_WELCOME_POPUP_PAGE_CONSTANTS
